import styled from 'styled-components';

import { formatPrice } from 'utils/price';

import { getPaymentMethodLabel } from 'helpers/paymentMethods';

import { DetailedTransactionFragmentFragment } from 'data/__generated__';
import { PaymentMethodStatusTag } from './PaymentMethodStatusTag';

export const PaymentMethods = ({
    paymentMethods,
}: {
    paymentMethods: DetailedTransactionFragmentFragment['paymentMethods'];
}) => {
    return (
        <>
            {paymentMethods?.map(
                ({ name, paymentMethodName, provider, type, amountUsed, status, explanation = '' }, index) => (
                    <PaymentMethodRow key={index}>
                        <PaymentMethodStatusTag status={status} />
                        <DetailsContainer>
                            {formatPrice(amountUsed || 0)} {getPaymentMethodLabel(paymentMethodName)}
                            {provider && `, fournisseur : ${provider}`}
                            {type && `, type : ${type}`}
                            {name && `, nom : ${name}`}
                            <strong>{explanation && ` : ${explanation}`}</strong>
                        </DetailsContainer>
                    </PaymentMethodRow>
                ),
            )}
        </>
    );
};

const DetailsContainer = styled.span`
    margin-left: 5px;
`;

const PaymentMethodRow = styled.div`
    display: flex;
    align-items: baseline;

    &:not(:first-child) {
        margin-top: 5px;
    }
`;
